export default __webpack_public_path__ + "navigation-guides-free-drive-ui-960-67d40357d8897cab93a595a3d17e2f7b.png";